import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";

import {
    openBackInStock,
    errorBackInStock,
    resetBackInStock,
    resetCustomerType,
    setCustomerType,
    successBackInStock,
} from "../actions/back-in-stock.actions";
import { BackInStockState, CustomerType } from "../models/back-in-stock.state";
import {
    selectBackInStockCustomerType,
    selectBackInStockLoading,
} from "../selectors/back-in-stock.selectors";

@Injectable()
export class BackInStockFacade {
    /**
     * Describe the loading status of the notify me tray
     */
    public loading$ = this.store.select(selectBackInStockLoading);
    public customerType$ = this.store.select(selectBackInStockCustomerType);

    constructor(private store: Store<BackInStockState>) {}

    public openBackInStock(): void {
        this.store.dispatch(openBackInStock());
    }

    public errorBackInStock(): void {
        this.store.dispatch(errorBackInStock());
    }

    public successBackInStock(): void {
        this.store.dispatch(successBackInStock());
    }

    public resetBackInStock(): void {
        this.store.dispatch(resetBackInStock());
    }

    public setCustomerType(type: CustomerType): void {
        this.store.dispatch(setCustomerType({ customerType: type }));
    }

    public resetCustomerType(): void {
        this.store.dispatch(resetCustomerType());
    }
}
